
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'PatientSummary',
  props: ['patient']
})
